module.exports = __webpack_public_path__ + "img/nothingBlue.45df0459.png";